import { render, staticRenderFns } from "./InvoiceTrial.vue?vue&type=template&id=d96ae08e&scoped=true&"
import script from "./InvoiceTrial.vue?vue&type=script&lang=js&"
export * from "./InvoiceTrial.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTrial.vue?vue&type=style&index=0&id=d96ae08e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96ae08e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VContainer,VSnackbar})
